import { Module, VuexModule, Mutation, MutationAction, getModule, Action } from 'vuex-module-decorators';
import { Configuration } from '@/models/configuration/Configuration';
import { ConfigurationService } from '@/services/index';
import store from '@/store';

import { AuthStatusTypeEnums } from '@/enums/AuthStatusTypeEnums';
import { UserWhitelistEnums } from '@/enums/UserWhitelistEnums';

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false };

export interface IAuthStoreState {
    isLoggedIn: boolean;
    isWhitelisted: UserWhitelistEnums;
    authStatus: AuthStatusTypeEnums;
}

@Module({ dynamic: true, store, name: 'authStore' })
class AuthStoreModule extends VuexModule implements IAuthStoreState {
    public isLoggedIn: boolean = false;
    public isWhitelisted: UserWhitelistEnums = UserWhitelistEnums.UNKNOWN;
    public authStatus: AuthStatusTypeEnums = AuthStatusTypeEnums.UNKNOWN;

    /**
     * Fetch isLoggedIn
     *
     * Note:
     * 'isLoggedIn' are replaced by returned object
     * whose shape must be `{isLoggedIn: [...]}`
     */
    @MutationAction({ mutate: ['isLoggedIn'] })
    public async SetIsLoggedIn(isLoggedIn: boolean) {
        return { isLoggedIn };
    }

    get GetIsLoggedIn() {
        return this.isLoggedIn;
    }

    get GetIsLoggedInText() {
        return this.isLoggedIn ? 'logged in' : 'not logged in';
    }

    @MutationAction({ mutate: ['isWhitelisted'] })
    public async SetIsWhitelisted(isWhitelisted: UserWhitelistEnums) {
        return { isWhitelisted };
    }

    get GetIsWhitelisted() {
        return this.isWhitelisted;
    }
}

export const AuthStore = getModule(AuthStoreModule);
